import angular from 'angular'
import identificationSummarize from './identificationSummarize'
import statisticsPurchaseRank from './statisticsPurchaseRank'
import goodsStatistics from './goodsStatistics'

export default angular
    .module('app.statistics.inputStatistics', [identificationSummarize, statisticsPurchaseRank, goodsStatistics])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.inputStatistics', {
            abstract: true,
            url: '/inputStatistics',
            template: '<div ui-view></div>',
            title: '进项统计',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/index.js